import { Checkbox, Icon, useTranslation } from '@testsigma/atoms';

interface SkipResignPanelProps {
  skipResign: boolean;
  onChangeSkipResign: (value: boolean) => void;
}

export const SkipResignPanel: React.FC<SkipResignPanelProps> = ({
  skipResign,
  onChangeSkipResign,
}) => {
  const { t } = useTranslation();
  return (
    <div className='flex items-center gap-x-2'>
      <Checkbox
        checked={skipResign}
        onChange={onChangeSkipResign}
        size='small'
        type='primary'
        label={t('uploads.form.label.skip_resign')}
      />
      <Icon
        name='info'
        toolTip={t('uploads.form.tooltip.skip_resign')}
        className='text-base text-secondary-500 !block'
      />
    </div>
  );
};
